import { Effect, Layer, Match } from "effect";
import { editorRevealFailure } from "./reveal-model.ts";
import { EditorRevealIo } from "./reveal-service.ts";

export const EditorRevealIoLive = Layer.succeed(EditorRevealIo, EditorRevealIo.of({
  apply: (editor, request) => Effect.try({ try: () => {
    Match.value(request).pipe(
      Match.tag("Line", value => {
        const line = Math.max(1, value.line);
        editor.setPosition({ lineNumber: line, column: 1 });
        editor.revealLineInCenter(line);
      }),
      Match.tag("Match", value => {
        const range = { startLineNumber: value.line, startColumn: value.start + 1, endLineNumber: value.line, endColumn: value.end + 1 };
        editor.setSelection(range);
        editor.revealRangeInCenter(range);
      }),
      Match.exhaustive
    );
    editor.focus();
  }, catch: editorRevealFailure })
}));
